<template functional>
  <label class="form-group">
    <slot />
    <input
      type="text"
      :value="props.value"
      @input="listeners.input($event.target.value)"
    >
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.form-group {
  width: 100%;

  input {
    width: 100%;
    padding: 5px 10px;
    box-shadow: none;
    border: none;
    border-radius: 5px;
    border: 1px solid rgba($color: #fff, $alpha: 0.2);
    background: darken($color-main-darker, 2);
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.25pt;
    margin-top: 5px;
  }
}
</style>
